import { Alert, AlertProps, AlertTitle, Stack, Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import {
  HookFormToggle,
  HookFormToggleProps,
} from 'ui-component/HookFormComponents/HookFormToggle';

export type HookFormToggleAlertProps = {
  severity?: AlertProps['severity'];
  variant?: AlertProps['variant'];
  children?: ReactNode;
} & HookFormToggleProps;

const HookFormToggleAlert: FC<HookFormToggleAlertProps> = ({
  children,
  severity = 'info',
  variant = 'outlined',
  label,
  sx,
  ...rest
}) => (
  <Alert
    severity={severity}
    variant={variant}
    icon={false}
    sx={{ ...sx, pl: 1 }}
  >
    <Stack direction="row" alignItems="center">
      <HookFormToggle sx={{ ml: 1 }} {...rest} />
      <Box>
        {!!label && <AlertTitle>{label}</AlertTitle>}
        {children}
      </Box>
    </Stack>
  </Alert>
);

export default HookFormToggleAlert;
